// frontend/src/pages/KioskPage.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../styles/KioskPage.css'; // <<< IMPORTANT: Import the new CSS file >>>

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function KioskPage({ user }) { // Assumes 'user' prop contains { tenant_id, kiosk_id }
  const [services, setServices] = useState([]); 
  const [selectedService, setSelectedService] = useState(null); 
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [showToken, setShowToken] = useState(false); 
  const [createdTokenNumber, setCreatedTokenNumber] = useState(""); 
  const navigate = useNavigate(); 

  const handleLogout = () => {
    localStorage.removeItem('currentUser'); 
    navigate('/login'); 
  };

  // Fetch services on component mount
  useEffect(() => {
    if (!user || !user.tenant_id) {
      setMessage("Kiosk user or tenant ID missing. Please log in again.");
      setLoading(false);
      return;
    }

    axios.get(`${BASE_URL}/api/services?tenant_id=${user.tenant_id}`)
      .then(res => {
        setServices(res.data);
        setLoading(false);
      })
      .catch(err => {
        setMessage("Error loading services.");
        setLoading(false);
        console.error("Error fetching services:", err);
      });
  }, [user]); 

  // Handle service selection
  const handleServiceSelect = (service) => {
    setSelectedService(service);
    setMessage(`Selected: ${service.name}. Click 'Get Token' to proceed.`);
    setShowToken(false);
  };

  // Create token
  const createToken = () => {
    if (!selectedService) {
      setMessage("Please select a service first!");
      return;
    }
    if (!user || !user.tenant_id || !user.kiosk_id) { 
        setMessage("User info missing. Please log in again.");
        return;
    }

    setLoading(true);
    setMessage("Generating and printing your token..."); 

    axios.post(`${BASE_URL}/api/tokens`, { 
      tenant_id: user.tenant_id,
      kiosk_id: user.kiosk_id,
      service_id: selectedService.id 
    })
      .then(res => {
        setCreatedTokenNumber(res.data.token_number);
        setShowToken(true);
        setMessage(`Your token: ${res.data.token_number} for ${selectedService.name}. Print Status: ${res.data.print_status || "Unknown"}`);
        setLoading(false);
      })
      .catch(err => {
         // --- CRITICAL FIX: Extract specific error message from backend response ---
         const errorMessage = err.response && err.response.data && err.response.data.error
         ? err.response.data.error // Use specific error message from backend
         : err.message || "An unknown error occurred."; // Fallback to generic Axios message
         setMessage(`Error: ${errorMessage}. Please try again.`); // Display the specific error
// --- END CRITICAL FIX ---
        setLoading(false);
        console.error("Error creating token:", err);
      });
  };

  // Reset to get another token
  const resetKiosk = () => {
    setSelectedService(null);
    setMessage("");
    setShowToken(false);
    setCreatedTokenNumber("");
  };

  if (loading) {
    return <div className="kiosk-container">Loading services...</div>; {/* Use class name */}
  }

  return (
    <div className="kiosk-page-wrapper">
        <div className="kiosk-main-header">  </div>
       <button 
        onClick={handleLogout} 
        className="kiosk-logout-button" /* Use class name */
      >
        Logout
      </button>
    
    <div className="kiosk-container"> {/* Use class name */}
      <h2 className="kiosk-header">Welcome to Our Service Kiosk</h2> {/* Use class name */}
      <p className="kiosk-message">{message}</p> {/* Use class name */}


      {!showToken ? (
        <div className="kiosk-content"> {/* Use class name */}
          <h3 className="kiosk-section-title">Please Select a Service:</h3> {/* Use class name */}
          <div className="kiosk-service-buttons"> {/* Use class name */}
            {services.length === 0 ? (
              <p>No services available. Please contact staff.</p>
            ) : (
              services.map(service => (
                <button
                  key={service.id}
                  onClick={() => handleServiceSelect(service)}
                  // Use conditional class name for selected state
                  className={`kiosk-service-button ${selectedService && selectedService.id === service.id ? 'selected' : ''}`} 
                >
                  {service.name}
                </button>
              ))
            )}
          </div>
          <button
            onClick={createToken}
            // Use conditional class name for disabled state
            className={`kiosk-get-token-button ${!selectedService || loading ? 'disabled' : ''}`}
            disabled={!selectedService || loading}
          >
            Get Token
          </button>
        </div>
      ) : (
        <div className="kiosk-token-display"> {/* Use class name */}
          <h3 className="kiosk-token-display-header">Your Token Number:</h3> {/* Use class name */}
          <p className="kiosk-token-number">{createdTokenNumber}</p> {/* Use class name */}
          <p className="kiosk-service-info">For: {selectedService?.name}</p> {/* Use class name */}
          <button onClick={resetKiosk} className="kiosk-reset-button"> {/* Use class name */}
            Get Another Token
          </button>
        </div>
      )}
      </div>
    </div>
  );
}

// <<< IMPORTANT: REMOVE THE INLINE STYLES OBJECT FROM HERE >>>
// const styles = { ... };